<template>
  <v-container fluid class="pa-0">
    <v-toolbar color="primary" class="toolbar">
      <v-container fluid pa-0>
        <v-row class="align-center justify-center">
          <v-col class="col-3 col-md-5 d-md-none">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  text
                  class="navbar-buttons primary--text justify-start pa-0"
                  color="white"
                  v-on="on"
                >
                  <v-icon size="26">menu</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item>
                  <v-list-item-title>
                    <v-btn
                      text
                      href="https://blog.ondivan.com.br/"
                      target="_blank"
                      class="navbar-buttons primary--text mr-2"
                    >
                      <v-icon class="mr-2">subject</v-icon>{{ $t('publicNavBar.blog') }}
                    </v-btn>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>
                    <v-btn to="/sobre" text class="navbar-buttons primary--text">
                      <img
                        :src="require('../assets/icon_ondivan.png')"
                        class="mr-3"
                        style="width: 20px"
                      />
                      Quem somos?
                    </v-btn>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>
                    <a href="/paciente" class="navbar-buttons white primary--text button-anchor">
                      <v-icon class="primary--text mr-2">record_voice_over</v-icon>Pacientes
                    </a>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>
                    <a href="/psicologo" class="navbar-buttons white primary--text button-anchor">
                      <v-icon class="primary--text mr-2">hearing</v-icon>Psicólogos
                    </a>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
          <v-col class="col-5 col-md-5 d-none d-md-block">
            <v-btn
              href="https://blog.ondivan.com.br/"
              target="_blank"
              color="white"
              class="navbar-buttons primary--text mr-2"
            >
              <v-icon>subject</v-icon>{{ $t('publicNavBar.blog') }}
            </v-btn>
            <v-btn to="/sobre" color="white" class="navbar-buttons primary--text">
              <img :src="require('../assets/icon_ondivan.png')" class="mr-2" style="width: 20px" />
              Quem somos?
            </v-btn>
          </v-col>
          <v-col class="col-7 col-md-2 offset-1 offset-md-0">
            <v-row class="align-center justify-md-center">
              <a href="/">
                <img :src="require('../assets/ondivan_marca_white.svg')" width="70%;" />
              </a>
            </v-row>
          </v-col>
          <v-col class="col-5 col-md-5 d-none d-md-block">
            <v-row class="justify-end">
              <a href="/paciente" class="navbar-buttons white primary--text button-anchor">
                <v-icon class="primary--text mr-2">record_voice_over</v-icon>Pacientes
              </a>
              <a href="/psicologo" class="navbar-buttons white primary--text button-anchor">
                <v-icon class="primary--text mr-2">hearing</v-icon>Psicólogos
              </a>
              <div id="languagePage" class="navbar-buttons white primary--text button-anchor">
                <v-select
                  v-model="selectedCountryValue"
                  @change="changePage"
                  :items="countries"
                  item-value="id"
                  solo
                  return-object
                  hide-details="auto"
                  id="mySelect"
                >
                  <template slot="selection" slot-scope="slotProps">
                    <img :src="slotProps.item.flag" />
                  </template>
                  <template slot="item" slot-scope="slotProps">
                    <img :src="slotProps.item.flag" />
                    {{ slotProps.item.name }}
                  </template>
                </v-select>
              </div>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
      <div id="languagePageMobile">
        <v-select
          v-model="selectedCountryValue"
          @change="changePage"
          :items="countries"
          item-value="id"
          solo
          return-object
          hide-details="auto"
        >
          <template slot="selection" slot-scope="slotProps" class="select">
            <img :src="slotProps.item.flag" />
          </template>
          <template slot="item" slot-scope="slotProps">
            <img :src="slotProps.item.flag" />
            {{ slotProps.item.name }}
          </template>
        </v-select>
      </div>
    </v-toolbar>
  </v-container>
</template>
<script>
import flagBr from '../assets/flag-br.svg';
import flagPt from '../assets/flag-pt.svg';
import getLanguage from '../utils/getLanguage';

export default {
  data: () => ({
    language: null,
    countries: [
      {
        id: 1,
        name: '(BR)',
        flag: flagBr,
      },
      {
        id: 2,
        name: '(PT)',
        flag: flagPt,
      },
    ],
  }),
  mounted() {
    this.language = getLanguage(window.location.href);
  },
  computed: {
    selectedCountryValue() {
      if (this.language === 'pt-BR') {
        return 1;
      } else {
        return 2;
      }
    },
  },
  methods: {
    changePage(value) {
      if (value.id === 1) {
        window.location.href = process.env.VUE_APP_SITE_BR;
      } else {
        window.location.href = process.env.VUE_APP_SITE_PT;
      }
    },
  },
};
</script>
<style lang="css" scoped>
.toolbar {
  overflow: hidden;
}

.button-anchor {
  border-radius: 8px;
  text-transform: uppercase;
  font-weight: 500;
  overflow: hidden;
  height: 36px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  text-decoration: none;
  margin: 0px 5px;
}
#languagePage {
  max-width: 110px;
  margin: 0px 5px;
  height: 36px;
  border-radius: 8px;
  padding: 0;
}

#languagePageMobile {
  display: None;
}

@media screen and (max-width: 767px) {
  .v-menu--inline {
    display: none !important;
  }

  .disappear-mobile {
    display: none;
  }

  .navbar-buttons {
    font-size: 10px !important;
    justify-content: start;
    margin: 0;
  }

  #mySelect .v-select .dropdown-toggle {
    padding: 5px;
  }

  #languagePageMobile {
    max-width: 80px;
    padding: 0;
    display: block;
    border-radius: 8px;
  }
}
</style>
